var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"rounded",attrs:{"color":"transparent","depressed":"","fab":"","small":""},on:{"click":function($event){return _vm.editor.commands.undo()},"mousedown":function($event){$event.stopPropagation();$event.preventDefault();}}},[_c('v-icon',[_vm._v("\n\t\tmdi-undo\n\t")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }